import { Subject } from "rxjs";
import { useEffect, useState } from "react";

export const PageLoaderComponent = () => {
    let isShow = false;
    const [loadingText, setLoadingText] = useState<string | null>(null);

    const handleShow = () => {
        if (isShow) return;
        isShow = true;
        document.getElementById('itb-global-page-loader')?.classList.add("show");
        document.getElementById('itb-global-page-loader')?.classList.add("fade");
    };

    const handleHide = () => {
        if (!isShow) return;
        isShow = false;
        document.getElementById('itb-global-page-loader')?.classList.remove("fade");

        setTimeout(() => {
            document.getElementById('itb-global-page-loader')?.classList.remove("show");
        }, 300);
    };

    useEffect(() => {
        const sub1 = PageLoader.PageLoaderShowRequestSubject.subscribe(flag => {
            flag ? handleShow() : handleHide();
        });

        const sub2 = PageLoader.PageLoaderLoadingTextSubject.subscribe(text => {
            setLoadingText(text || null);
        });

        return () => {
            sub1.unsubscribe();
            sub2.unsubscribe();
        };
    }, []);

    return (
        <div id="itb-global-page-loader" className='page-loader-container'>
            <div>
                <img src="/images/logo-sm.svg" alt='logo' />
                <div className="spinner-loader"></div>

            </div>
            {loadingText && (
                <div className="loading-text">
                    {loadingText}
                </div>
            )}
        </div>
    );
};

export class PageLoader {
    static PageLoaderShowRequestSubject = new Subject<boolean>();
    static PageLoaderLoadingTextSubject = new Subject<string | null>();

    static show(text?: string) {
        this.PageLoaderLoadingTextSubject.next(text ?? null);
        this.PageLoaderShowRequestSubject.next(true);
    }

    static hide() {
        this.PageLoaderShowRequestSubject.next(false);
        this.PageLoaderLoadingTextSubject.next(null);
    }
}